import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { projectSettingServicedeskEmployeeOnboardingConfigurationRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskEmployeeOnboardingConfigurationRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import ServicedeskEmployeeOnboardingConfigurationComponent, {
	LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration,
} from './ui/service-desk-employee-onboarding-configuration/ServicedeskEmployeeOnboardingConfigurationComponent.tsx';

const projectSettingServicedeskEmployeeOnboardingConfigurationPageEntryPoint = createPageEntryPoint(
	{
		main: {
			root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
				/* webpackChunkName: "async-project-setting-servicedesk-employee-onboarding-configuration" */ '@jira/spa-apps__service-desk-employee-onboarding-configuration/src/EmployeeOnboardingConfigurationView.tsx',
				{ entryFsSsrLiftImportToModule: false },
			),
			getPreloadProps: () => ({}),
		},
	},
);

export const projectSettingServicedeskEmployeeOnboardingConfigurationRouteEntry: ReturnType<
	typeof createEntry
> = createEntry(projectSettingServicedeskEmployeeOnboardingConfigurationRoute, () => ({
	group: 'project-settings-servicedesk',
	ufoName: 'jsm-employee-onboarding-configuration',

	// eslint-disable-next-line no-restricted-syntax
	component: fg('nike_entrypoint_migration_batch_2')
		? undefined
		: ServicedeskEmployeeOnboardingConfigurationComponent,

	entryPoint: () =>
		fg('nike_entrypoint_migration_batch_2')
			? projectSettingServicedeskEmployeeOnboardingConfigurationPageEntryPoint
			: undefined,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
		sidebarId: SidebarIdProjectSettings,
	},

	resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],

	forPaint: [
		LazyAtlassianNavigation,
		LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration,
	],

	perfMetricKey: 'jsm-employee-onboarding-configuration',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
